export default __webpack_public_path__ + "static/media/640_portfolio02-nl-mobile.94929e32.png";